import { RU_TARGET_COLUMNS } from "../constants/columns";
import { getRowErrorMessage } from "./validationHelpers";

export const filterValidatedRows = (rows = [], searchValue = "") => {
  const query = searchValue.trim().toLowerCase();
  if (!query) return rows;

  const searchableFields = RU_TARGET_COLUMNS.map((col) => col.field).filter(
    Boolean
  );

  return rows.filter((row) =>
    searchableFields.some((field) => {
      const value =
        field === "errorMessage" ? getRowErrorMessage(row) : row?.[field];
      return value?.toString().toLowerCase().includes(query);
    })
  );
};
